import React from 'react'
import { Component } from 'react';
import axios from 'axios';
import { baseURL } from '../../../constants/applicationConstants.js';
import ArticlesJsx from './articles.jsx';
import { BLOG_URL_TOKEN, BLOG_URL } from '../../../constants/applicationConstants.js';
import { Loader } from '../../common/loader/loader.jsx';
import { fetchArticleDataFromAPI } from '../../../shared/helper.js';


export default class Articles extends Component {
  constructor(props) {
    super(props);
    this.state = {
      categoryData: null,
      isLoading: false,
      categoryName: "",
      subCategoryData: null,
      categoryId: null,
      subCategoryId: null,
      subCategoryName: null,
      subCategories: [],
      categories: [],
      selectedCategoryNames: [],
      selectAll: false,

      blogData: null,
      isProcessing: false,
      topOffers: null,
      page: 1,
      totalSubCategories: "",
      disableSelectAll: true,
      input: "",

      blogType: 'featured,main_news,glossory,trending',
      quoteData: {
        type: null,
        name: null,
        email: null,
        phone: null,
        postalCode: null
      },
      formError: {},
      expertData: null,
      productData: null,
      offerData: null
    }
  }
  getType = {
    Featured: 'main_news',
    Trending: "trending",
    Latest: "featured",
    Glossary: "glossory"
  }

  hitSearch = () => {
    this.state.page = 1;
    const { paramName } = this.getQueryParams();
    if (this.state.input == "") {
      this.state.input = paramName;
    }

    this.props.history.push({ pathname: "searchArticles", search: `search=${this.state.input}` });


    this.onSubmitButtonClick();
  }

  hitShowAll = (type) => {
    this.state.page = 1;

    if (this.state.categoryName) {
      this.props.history.push({ pathname: "searchArticles", search: `category=${this.state.categoryName}&type=${type}` });

    }
    else {
      this.props.history.push({ pathname: "searchArticles", search: `type=${type}&ddd` });

    }
    sessionStorage.setItem("selectCategory", this.state.categories)

  }

  searchOfferByKeyword = (e) => {
    this.state.input = e.target.value;
    this.setState({ input: e.target.value })
  }

  onSubmitButtonClick = () => {
    const { catName } = this.getQueryParams();
    var data = new FormData();
    data.append('limit', '10');
    data.append('device_token', '20.204.66.244');
    data.append('paged', this.state.page)
    data.append('search', this.state.input)
    if (catName) {
      data.append('cat_slug', catName)
    }
    this.setState({ isProcessing: true })

    axios.post(`${BLOG_URL}`, data,
      {
        headers: { 'Eba-access-api-base-token': BLOG_URL_TOKEN }
      }).then(res => {
        this.setState({ articleData: res.data, isProcessing: false });
      }).catch(err => {
        this.setState({ isProcessing: false });
      })
  }

  componentDidMount = () => {
    const { location } = this.props;
    const params = new URLSearchParams(location.search);





    this.setState({ isLoading: true, categoryName: params.get('category') || "" })

    const categoryIdFromPev = sessionStorage.getItem("selectCategory");

    this.getcategorySubcategory(true);
    setTimeout(() => {
      categoryIdFromPev ? this.checkCategoryFromPrevious() : this.selectAllIds()


    }, 1000);
    setTimeout(async () => {
      this.blogdataCall("");
      this.setState({ selectAll: true })

    }, 500);

  }

  blogdataCall = async (catSlugs) => {
    this.setState({ isProcessing: true });
    const { paramName } = this.getQueryParams();

    const type = 'featured,main_news,glossory,trending'
    const fetchedData = await fetchArticleDataFromAPI(catSlugs || "", type || "", this.state.page || "", paramName || "");
    this.setState({ blogData: fetchedData, isProcessing: false });

  }

  getcategorySubcategory = (firstFetch=false) => {
    this.setState({ isLoading: true })
    let token = JSON.parse(sessionStorage.getItem('token'));
    axios.get(`${baseURL}/institutionCategoriesAndSubCategories`, {
      headers: { 'x-access-token': token }
    }).then(res => {
      this.setState({ categoryData: res.data.data, isLoading: false })
      // Calculate the total number of subInstitutionCategories
      const totalSubCategories = this.state.categoryData?.reduce((acc, category) => {
        return acc + (category.subInstitutionCategories ? category.subInstitutionCategories.length : 0);
      }, 0);

      // Set the totalSubCategories in state
      this.setState({ totalSubCategories });
    }).then(res => {
      if(firstFetch)
      {
          this.selectAllIds()
      }
  })
  }
  checkCategoryFromPrevious = () => {
    const categoryIdsFromPrev = sessionStorage.getItem("selectCategory");

    this.setState({ selectAll: false,disableSelectAll:false });

    if (categoryIdsFromPrev) {
      // Convert "1,3" -> [1, 3]
      const categoryIdArray = categoryIdsFromPrev
        .split(',')
        .map(id => parseInt(id.trim()))
        .filter(id => !isNaN(id));

      categoryIdArray.forEach(categoryId => {
        const selectedCategory = this.state.categoryData.find(
          category => category.institutionCategoryId === categoryId
        );

        if (selectedCategory) {
          this.selectCategory1(selectedCategory);
        }
      });
    }
  };

  selectCategory1 = (selectedCategory) => {
    const institutionCategoryIds = selectedCategory.subInstitutionCategories.map(subCategory => subCategory.institutionCategoryId);

    // Add the category and its subcategories to the state
    this.setState(prevState => ({
      subCategories: [...prevState.subCategories, ...institutionCategoryIds],
      categories: [...prevState.categories, selectedCategory.institutionCategoryId],
      selectedCategoryNames: [...prevState.selectedCategoryNames, selectedCategory.name],
    }));

    // Optionally trigger a filtering or update
    setTimeout(() => {
      this.filterCatData();
    }, 500);
  }
  selectAllHit = (e) => {
    const { checked } = e.target
    if (!checked) {
      this.setState({ selectAll: false })
    } else {
      this.setState({ selectAll: true })

    }
    if (checked) {
      this.setState({ allOffersData: this.state.overallOffers, keyword: "", disableSelectAll: true })
      this.selectAllIds()
      this.blogdataCall("");


    }


  }

  onCatgoryClick = (value) => {
    const subData = this.state.categoryData.filter(itm => itm.institutionCategoryId == value)

    this.setState({ subCategoryData: subData[0]?.subInstitutionCategories })
  }
  getQueryParams() {
    const { location } = this.props;
    const params = new URLSearchParams(location.search);
    return {
      paramName: params.get('search'), // Change 'paramName' to your actual query parameter name
      catName: params.get('category') ?? null, // Change 'paramName' to your actual query parameter name
    };

  }


  // filter all selected id
  selectAllIds = () => {

    sessionStorage.removeItem("selectCategory")
    const institutionCategoryIds = this.state.categoryData?.map(category => category.institutionCategoryId);
    const institutionCategoryNames = this.state.categoryData?.map(category => category.name);

    this.setState({ categories: institutionCategoryIds })
    this.setState({ selectedCategoryNames: institutionCategoryNames })


    // Extract sub-institution category IDs as well
    this.state.categoryData?.forEach(category => {
      if (category?.subInstitutionCategories) {
        const subIds = category?.subInstitutionCategories?.map(subCategory => subCategory.institutionCategoryId);
        // institutionCategoryIds.push(...subIds);
        this.setState(prevState => ({
          subCategories: [...prevState.subCategories, ...subIds] // Spread existing items and add new items
        }));
        // this.setState({ subCategories: ...subIds })

      }
    });

    this.setState({ institutionCategoryIds });
  }




  filterCatData = () => {

    // Convert selected category names to lowercase for case-insensitive comparison
    const selectedCategoryNamesModified = this.state.selectedCategoryNames.map(name =>
      name.toLowerCase().replace(/\s+/g, '-')
    );
    this.setState({ categoryName: selectedCategoryNamesModified })
    this.blogdataCall(selectedCategoryNamesModified)
    if (this.state.subCategories.length === 0) {

      this.blogdataCall("");

      this.setState({ selectAll: true })
      this.selectAllIds()

    }
  };








  selectCategory = (data, e) => {
    sessionStorage.removeItem("selectCategory")
    sessionStorage.setItem("changing", true)

    const { checked } = e.target


    this.setState({ selectAll: false, disableSelectAll: false })

    this.triggerSelectAll()        // 
    const selectedId = data.institutionCategoryId;
    this.setState({ selectedCategoryId: selectedId });

    const selectedCategory = this.state.categoryData.find(category => category.institutionCategoryId === selectedId);


    if (selectedCategory) {
      const insInsideCat = selectedCategory.subInstitutionCategories
      const institutionCategoryIds = insInsideCat.map(category => category.institutionCategoryId);


      if (checked) {
        this.setState((prevState) => ({
          subCategories: [...prevState.subCategories, ...institutionCategoryIds],
        }));
        this.setState({ page: 1 })


      } else {

        this.setState((prevState) => ({
          subCategories: prevState.subCategories.filter(
            (id) => !institutionCategoryIds.includes(id) // Remove IDs present in newIds
          )
        }));
        this.setState({ page: 1 })
      }
    } else {
      this.setState({ subCategories: [] });
    }
    setTimeout(() => {
      this.filterCatData()

    }, 500);


    this.setState((prevState) => {
      const { categories } = prevState;

      // Check if the id is already in the categories
      if (categories.includes(data.institutionCategoryId)) {
        // Remove the id
        return { categories: categories.filter(selectedId => selectedId !== data.institutionCategoryId) };
      } else {
        // Add the id
        return { categories: [...categories, data.institutionCategoryId] };
      }
    });
    this.setState((prevState) => {
      const { selectedCategoryNames } = prevState;

      // Check if the id is already in the selectedCategoryNames
      if (selectedCategoryNames.includes(data.name)) {
        // Remove the id
        return { selectedCategoryNames: selectedCategoryNames.filter(selectedId => selectedId !== data.name) };
      } else {
        // Add the id
        return { selectedCategoryNames: [...selectedCategoryNames, data.name] };
      }
    });
  }


  handleCheckboxChange = (id) => (event) => {
    if (event.target.checked) {
      // Add ID to the selected array if not already present
      this.setState((prevState) => ({
        selectedIds: prevState.selectedIds.includes(id)
          ? prevState.selectedIds
          : [...prevState.selectedIds, id]
      }));
    } else {
      // Remove ID from the selected array when unchecked
      this.setState((prevState) => ({
        selectedIds: prevState.selectedIds.filter((selectedId) => selectedId !== id)
      }));
    }
  };















  triggerSelectAll = () => {
    setTimeout(() => {
      const uniqueData = new Set(this.state.subCategories);

      // Get the length of the unique data
      const uniqueCount = uniqueData.size;

      if (uniqueCount >= this.state.totalSubCategories) {
        this.setState({ selectAll: true })
      }
      if (uniqueCount === this.state.totalSubCategories) {
        this.setState({ disableSelectAll: true })

      }
    }, 500);

  }
  selectSubCategory = (data) => {
    sessionStorage.removeItem("selectCategory")
    sessionStorage.setItem("changing", true)
    this.setState({ selectAll: false, disableSelectAll: false })

    this.triggerSelectAll()
    this.setState((prevState) => {
      if (prevState.subCategories.includes(data.institutionCategoryId)) {
        // If the ID is already selected, remove it
        return { subCategories: prevState.subCategories.filter((prevId) => prevId !== data.institutionCategoryId) };
      } else {
        // If the ID is not selected, add it
        return { subCategories: [...prevState.subCategories, data.institutionCategoryId] };
      }
    });

    setTimeout(() => {
      this.filterSubData()

    }, 500);

    // console.warn("selected sub cat", data,this.state.checkedCats)

  }
  onCategoryClickMob = (catId, catName) => {
    this.setState({ isProcessing: true })

    this.props.history.replace('/')
    this.props.history.push(`/articles?category=${catName}`)
    this.setState({ categoryId: catId, categoryName: catName });
    const type = 'featured,main_news,glossory,trending'
    const { paramName } = this.getQueryParams();

    setTimeout(async () => {
      const fetchedData = await fetchArticleDataFromAPI(this.state.categoryName || "", type || "", this.state.page || "", paramName || "");
      this.setState({ blogData: fetchedData, isProcessing: false });

    }, 400);
    // this.setState({
    //     subCategoryData: this.state.categoryData.filter(catDT => catDT.name === catName)[0]?.subInstitutionCategories
    // }, () => this.isFromSubmissionBlock())

  }
  getQueryParams() {
    const { location } = this.props;
    const params = new URLSearchParams(location.search);
    return {
      paramName: params.get('search'), // Change 'paramName' to your actual query parameter name
      catName: params.get('category') ?? null, // Change 'paramName' to your actual query parameter name
    };

  }



  render() {
    return (
      <div>
        <ArticlesJsx
          subCategories={this.state.subCategories}
          categories={this.state.categories}
          categoryData={this.state.categoryData}

          onCategoryClick={this.onCategoryClick}
          categoryName={this.state.categoryName}
          selectAllHit={this.selectAllHit}
          page={this.state.page}
          subCategoryData={this.state.subCategoryData}
          selectCategory={this.selectCategory}
          selectSubCategory={this.selectSubCategory}
          selectAll={this.state.selectAll}
          hitSearch={this.hitSearch}
          hitShowAll={this.hitShowAll}
          searchOfferByKeyword={this.searchOfferByKeyword}
          input={this.state.input}
          disableSelectAll={this.state.disableSelectAll}
          onCategoryClickMob={this.onCategoryClickMob}

          blogData={this.state.blogData} />
        {this.state.isProcessing && <Loader />}

      </div>
    )
  }
}